<template>
  <div class="client">
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells position="between">
        <app-cells :indent="false">
          <h1 class="title">
            <app-cells :indent="false">
              <button v-if="is_sales_general_manager" @click="onCopyFamilyLink(home_data.hash)" type="button" class="client__copy">
                {{ home_data.personal_detail.first_name }} {{ home_data.personal_detail.last_name }}
              </button>
              <span v-else>{{ home_data.personal_detail.first_name }} {{ home_data.personal_detail.last_name }}</span>
              <router-link
                v-if="home_data.group"
                :to="{ name: 'clients-groups-general', params: { id: home_data.group.id } }"
                class="client__link"
              >
                (Group: {{ home_data.group.name }})
              </router-link>
            </app-cells>
          </h1>
          <div v-if="!is_sales_manager" class="manager-title">
            <div class="manager-title__photo">
              <img :src="getUserAvatar(home_data.created_by.crop.crop_url)" alt="Avatar">
            </div>
            <span class="manager-title__name">{{ home_data.created_by.full_name }}</span>
          </div>
          <span class="title__update">Last Update: {{ dateTimeFormat(home_data.personal_detail.updated_at) }}</span>
        </app-cells>
        <a
          v-if="is_superuser"
          :href="`${admin_url}clients/client/${$route.params.id}/change/`"
          target="_blank"
          class="btn btn--blue"
        >
          Django
        </a>
      </app-cells>
      <div class="client__title" v-if="home_data.group && (home_data.group.itinerary || home_data.group.asana)">
        <a
          v-if="home_data.group.itinerary"
          :href="home_data.group.itinerary"
          target="_blank"
          class="client__text-link"
        >
          <img src="@/assets/img/story-itinerary-icon.svg" alt="Link">
          Open make a story Itinerary.
        </a>
        <a
          v-if="home_data.group.asana"
          :href="home_data.group.asana"
          target="_blank"
          class="client__text-link"
        >
          <img src="@/assets/img/story-itinerary-icon.svg" alt="Link">
          Open Asana project.
        </a>
      </div>
      <div class="client__wrapper">
        <section class="client__section client__section--flight">
          <app-cells position="between" :indent="false">
            <home-flight :transport="home_data.transport" @update="getClientData" />
          </app-cells>
        </section>
        <section class="client__section client__section--personal">
          <home-personal
            @getClientData="getClientData"
            :personal="home_data.personal_detail"
            :climbing_insurance="home_data.climbing_insurance"
            :safari_insurance="home_data.safari_insurance"
            :climbing_insurance_required="home_data.requirements.climbing_insurance_required"
            :safari_insurance_required="home_data.requirements.safari_insurance_required"
            :medical_clearance_required="home_data.requirements.medical_clearance_required"
            :common="common"
            :requirements="home_data.requirements"
          />
        </section>
        <section v-if="home_data.requirements.medical_clearance_required" class="client__section client__section--medical">
          <home-medical :medical="home_data.medical_clearance" :client_hash="home_data.hash" />
        </section>
        <section class="client__section client__section--activities">
          <div class="frame-tabs">
            <div class="frame-tabs__controls">
              <button
                @click="tabs_activities = true"
                class="frame-tabs__button"
                :class="{ 'frame-tabs__button--active': tabs_activities }"
              >
                Client activities
              </button>
            </div>
            <div class="frame-tabs__content">
              <transition name="fade" mode="out-in">
                <template v-if="tabs_activities">
                  <home-activities :activities="home_data.activities" :client_hash="home_data.hash" />
                </template>
              </transition>
            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import { getClient } from '@/http'
import { format, parseISO } from 'date-fns'
import HomeFlight from '@/views/clients/detail/components/Flight'
import HomePersonal from '@/views/clients/detail/components/Personal'
import HomeMedical from '@/views/clients/detail/components/Medical'
import HomeActivities from '@/views/clients/detail/components/Activities'

export default {
  name: 'ClientsDetail',
  components: { HomeFlight, HomePersonal, HomeMedical, HomeActivities },
  data() {
    return {
      home_data: {
        activities: [],
        medical_clearance: null,
      },
      tabs_activities: true,
      is_loaded: false,
      common: {
        content_language: null
      },
      family_url: process.env.VUE_APP_FAMILY,
      branded_url: process.env.VUE_APP_FAMILY_PARTNER,
      admin_url: process.env.VUE_APP_ADMIN_URL,
    }
  },
  computed: {
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager') || this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_superuser() {
      return this.$store.state.userData.is_superuser
    },
  },
  created() {
    this.getClientData()
  },
  methods: {
    onCopyFamilyLink(hash) {
      const string = `${this.home_data.group.branded_personal_area ? this.branded_url : this.family_url}${hash}`
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Link copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getClientData() {
      getClient(this.$route.params.id).then(res => {
        this.home_data = res.data
        this.common = {
          content_language: res.data.content_language,
          // tour_operator: res.data.tour_operator,
          // tour_operator_manager: res.data.tour_operator_manager,
          // tags: res.data.tags,
          category: res.data.category,
          // managers: res.data.managers
        }
        this.is_loaded = true
      })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>

<style scoped lang="sass">
.client__wrapper
  max-width: 950px

.client__section--flight
  margin-bottom: 46px

.client__section--personal
  margin-bottom: 40px

.client__section--medical
  margin-bottom: 40px

.client__section--activities
  margin-bottom: 70px

.client__link
  display: flex
  flex-direction: column
  width: max-content
  color: $color-text-base
  font-size: 24px
  font-weight: 600
  transition: color 0.3s

  &:after
    content: ''
    width: 100%
    height: 2px
    border-radius: 3px
    background-color: #aae182
    transform: translateY(-1px)
    transition: opacity 0.3s

  &:hover
    &:after
      opacity: 0

.client__copy
  width: max-content
  color: $color-text-base
  font-size: 24px
  font-weight: 600
  transition: color 0.3s

  &:active
    color: $color-theme

  @media (hover: hover)
    &:hover,
    &:focus-visible
      color: $color-theme

.client__title
  display: flex
  gap: 10px
  margin-bottom: 20px
  font-size: 14px
  font-weight: 500

  span
    font-weight: 400
    text-transform: none

.client__title--upper
  margin-bottom: 0
  text-transform: uppercase

.client__title--no-indent
  margin-bottom: 0

.client__text-link
  display: flex
  gap: 10px
  align-items: center
  color: $color-theme
  font-size: 14px
  font-weight: 600
  transition: color 0.3s

  img
    flex-shrink: 0

  &:hover
    color: #679c0d

.client__note
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 40px
  padding: 6px 10px
  border: 1px solid #ffa51f
  color: #404040
  font-size: 12px

.client__part
  margin-bottom: 20px

.client__part--indent
  margin-bottom: 40px

.client__header
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 20px
  padding: 10px 0
  border-top: 1px solid #eaeaea
  border-bottom: 1px solid #eaeaea

.client__icon rect
  fill: #c5c5c5

.client__icon--completed rect
  fill: $color-theme

.client__row
  display: grid
  gap: 10px 20px

.client__row--mix-1
  grid-template-columns: 200px 200px 154px 200px

.client__row--mix-2
  grid-template-columns: 200px 200px 154px 162px 154px

.client__row--mix-3
  grid-template-columns: 200px 420px

.client__row--mix-4
  grid-template-columns: 200px 200px 135px 135px 200px

.client__row--type-200
  grid-template-columns: repeat(4, 200px)
</style>
